import {getBffCsrf} from "@project/sdk/security";
import {queryOptions} from "@tanstack/react-query";

import {queryPolicyDefaults} from "../../../shared/query/query-policies";
import {authKeys} from "../../auth-keys";

import {authCsrfTokenSchema} from "./get-csrf-token.schema";

export function getCsrfTokenQueryOptions() {
  return queryOptions({
    ...queryPolicyDefaults.ephemeral,
    queryFn: async () => {
      const token = await getBffCsrf();

      return authCsrfTokenSchema.parse(token);
    },
    queryKey: authKeys.csrf(),
  });
}
